
<div class="col-12">
  <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <strong> Thank you for visiting Kawneer’s Overstock page.  Take advantage of these deals while they last!</strong>
  </div>
</div>
<div class="col-12">
  <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <i>
      All orders for Overstock items will be processed on this page. Overstock items cannot be added to the KawneerDirect cart or included on a standard KawneerDirect order.
      These items are sold on a 'first come, first served' basis with limited supplies. Selecting "Add to Order" does not guarantee an Overstock item for purchase.
      Items purchased will be shipped from the location noted in the "ships From" column without exception, with shipping costs invoiced accordingly. The highly reduced Overstock prices mean the KawneerDirect discount and your pricing modifier do not apply to these items. Please check this page routinely, as additional Overstock inventory will be added regularly.
    </i>
  </div>
</div>

<kendo-panelbar #panelbar>
  <kendo-panelbar-item [expanded]="true" title="">
    <ng-template kendoPanelBarItemTitle>
      <span>Select Item</span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <kendo-grid #grid #AdvanceSearchGrid [data]="itemListGridData "
                  class="advanceMainGridCls"
                  [sortable]="true"
                  [navigable]="true"
                  [filterable]="true" [groupable]="false"
                  [reorderable]="true" [resizable]="false"
                  [pageSize]="gridState.take"
                  [skip]="gridState.skip"
                  [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }" [columnMenu]="false"
                  [sort]="gridState.sort"
                  [filter]="gridState.filter"
                  (sortChange)="itemSelectionGridSortChange($event)"
                  (pageChange)="itemSelectionGridPageChange($event)"
                  (dataStateChange)="itemSelectionDataStateChange($event)"
                  [loading]="itemGridLoading">

        <kendo-grid-column media="(min-width: 1050px)" field="itemId" title="{{labelList.imageLbl}}" [filterable]="false" [sortable]="false" [editable]="false"
                           [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="product">
              <img src="{{imageURL}}{{dataItem.imageName}}" *ngIf="dataItem.imageName != 'NA'" class="OverStockImage" (error)="handleMissingImage($event,dataItem)" alt="" style="height:50px;width:75px;" />
              <!--<span *ngIf="!expanded" style="display:none;">{{isCategoryExpanded(true)}}</span>-->
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="longItemNumber" title="{{labelList.itemNumberLbl}}" [columnMenu]="false" [filterable]="true" [editable]="false" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem><span>{{dataItem.longItemNumber}}</span>
            <span *ngIf="itemDocExistsList.includes(dataItem.itemId)">
              <button kendoButton [icon]="'download'" (click)="onClickLongItemNumber(dataItem)" class="m-2 btn btn-success btnSizeCls"></button>
            </span>
          </ng-template>
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column"
                                           [filter]="filter"
                                           (inputBlur)="applyFilter($event,'longItemNumber')"
                                           (input)="onFilter($event,'longItemNumber')">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="description" title="{{labelList.itemDescriptionLbl}}" [editable]="false" [width]="150">
          <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
            <kendo-grid-string-filter-cell [column]="column"
                                           [filter]="filter"
                                           (blur)="applyFilter($event,'description')"
                                           (input)="onFilter($event,'description')">
              <kendo-filter-contains-operator></kendo-filter-contains-operator>
            </kendo-grid-string-filter-cell>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="availableLocName" title="Ships From" [width]="130">
          <ng-template kendoGridCellTemplate let-dataItem><span>{{dataItem.availableLocName}}</span></ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="currentInventory" title="Available" [width]="80"
                           [columnMenu]="false" [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem><span>{{dataItem.currentInventory}}</span></ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="discount" title="Price" [width]="130"
                           [columnMenu]="false" [filterable]="false" [editable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <p style="margin:0px;"><b>{{dataItem.salePrice|currency}}</b></p>
            <div *ngIf="dataItem.discount > 0 && dataItem.basePrice > 0" style="border: 1px solid #000; border-radius: 10px; width: 120px; height: 20px; background-color: green; text-align: center; color: white; font-weight: bold;">
              Save {{dataItem.discount}} %
            </div>
            <p *ngIf="dataItem.discount > 0 && dataItem.basePrice > 0" style="color: lightgray; padding: 0px;margin:0px;"><del>{{dataItem.basePrice|currency}}</del> List</p>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column media="(min-width: 1050px)" field="orderQty" title="Order Qty" [width]="80"
                           [columnMenu]="false" [filterable]="false" [editable]="false" [sortable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-numerictextbox [value]="1"
                                  [format]="'n'"
                                  [decimals]="0"
                                  [min]="1"
                                  [autoCorrect]="autoCorrect"
                                  changeValueOnScroll="false"
                                  (valueChange)="handleItemQtyChanged($event, dataItem)"
                                  class="QuantityCls">
              <!--[ngClass]="{ 'ng-invalid ng-touched': dataItem?.isInavlidQuantity}"-->
              <!--(valueChange)="handleItemQtyChanged($event, dataItem)"-->
            </kendo-numerictextbox>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-command-column media="(min-width: 1050px)" title="{{labelList.selectionLbl}}" [width]="135">
          <ng-template kendoGridCellTemplate let-dataItem>
            <button kendoButton [icon]="'shopping-cart'" class="m-2 clearKendoButton btn btn-success btnSizeCls"
                    (click)="addItemToCart(dataItem)">
              {{labelList.addToCartLbl}}
            </button>
            <br>
          </ng-template>
        </kendo-grid-command-column>
        <ng-template kendoGridNoRecordsTemplate>
        </ng-template>
      </kendo-grid>
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
          <button kendoButton primary="true" class="m-3" (click)="continueToOrderDetailsPanel(1)">
            Proceed To Review Items
          </button>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item [expanded]="false">
    <ng-template kendoPanelBarItemTitle>
      <span>Review Selection</span>
    </ng-template>
    <ng-template kendoPanelBarContent>
      <section class="margin-10">
        <div style="padding:20px;">
          <div class="row">
            <div class="col-md-12">
              <kendo-grid #grid #cartGrid [data]="itemReviewGridResult"
                          [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
                          class="checkOutReviewGridCls"
                          [pageSize]="itemReviewGridState.take"
                          [skip]="itemReviewGridState.skip"
                          [sortable]="false"
                          [navigable]="true"
                          [resizable]="false"
                          [groupable]="false"
                          [selectable]="false"
                          (pageChange)="itemReviewGridPageChange($event)">


                <kendo-grid-column media="(min-width: 1050px)" title="{{cartReview.lineLbl}}" [width]="60" [resizable]="false" [sortable]="true" [groupable]="false"
                                   [editable]="false" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">

                  <ng-template kendoGridCellTemplate class="d-flex justify-content-center" let-rowIndex="rowIndex">
                    <strong>{{rowIndex + 1}}</strong>
                  </ng-template>
                  <ng-template kendoGridFooterTemplate>
                    <div class="post-indicator-text">
                      <div>
                        <div>
                          {{cartReview.gridTextLbl1}}
                        </div>
                        <div>
                          {{cartReview.gridTextLbl2}}
                        </div>
                        <!--<div>
                          {{cartReview.gridTextLbl3}}
                        </div>-->
                      </div>
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="longItemNumber" [minResizableWidth]="70" [width]="120" title="{{cartReview.itemLbl}}"
                                   [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.longItemNumber}}
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="description" [minResizableWidth]="180" [width]="180"
                                   title="{{cartReview.descriptionLbl}}" [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                </kendo-grid-column>
                <kendo-grid-column media="(min-width: 1050px)" field="availableLocName" title="Ships From" [width]="130">
                  <ng-template kendoGridCellTemplate let-dataItem><span>{{dataItem.availableLocName}}</span></ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="salePrice" title="{{cartReview.unitPriceLbl}}"
                                   [width]="80" [minResizableWidth]="20">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.salePrice.toFixed(2) | currency}}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(min-width: 1050px)" [filterable]="false" [sortable]="false" field="orderQty" title="{{cartReview.quantityLbl}}"
                                   [width]="80" [minResizableWidth]="20">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.orderQty}}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="salePrice" [minResizableWidth]="70" [width]="100"
                                   title="{{cartReview.extendedPriceLbl}}">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.salePrice.toFixed(2) *dataItem.orderQty | currency}}
                  </ng-template>
                  <ng-template kendoGridFooterTemplate>
                    <h4 class="cartTotalInGrid">
                      {{calculateOrderTotal | currency}} -
                      {{cartReview.totalPriceLbl}}
                    </h4>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(min-width: 1050px)" [editable]="false" field="" [minResizableWidth]="70" [width]="100"
                                   title="Action">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <button class="k-button k-grid-remove-command btn-sample-admin-grid-edit"
                            (click)="showCofirmationDialogToRemoveItemFromReviewGrid(dataItem)">
                      <span class="k-icon k-i-trash">
                      </span>
                    </button>
                  </ng-template>
                </kendo-grid-column>
                <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                  <kendo-pager-info></kendo-pager-info>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
                </ng-template>
              </kendo-grid>
            </div>
          </div>
        </div>
      </section>
      <div class="col-12">
        <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
          <button kendoButton primary="true" class="m-3" (click)="continueToOrderDetailsPanel(2)">
            Continue to Order Details
          </button>
        </div>
      </div>
    </ng-template>
  </kendo-panelbar-item>
  <kendo-panelbar-item [expanded]="false">
    <ng-template kendoPanelBarItemTitle>
      <span>Place Order</span>
      <!--<div style="width:20px;height:20px;border:2px solid green;border-radius:10px;text-align:center;">
        5
      </div>-->
    </ng-template>
    <ng-template kendoPanelBarContent>
      <section class="margin-10">
        <div style="padding:20px;">
          <div class="row">
            <div class="col-md-6">
              <b>Shipping Address</b><br />
              {{currentShipToAddr?.customerNumber}}-{{currentShipToAddr?.customerName}}<br />
              {{currentShipToAddr?.addressLine1}}{{currentShipToAddr?.addressLine2}}<br />
              {{currentShipToAddr?.city}}, {{currentShipToAddr?.state}} {{currentShipToAddr?.zipCode}}
              <br />
              <button kendoButton primary="true" class="m-3" (click)="launchAddressChangeModal()">
                Change
              </button>
            </div>
            <div class="col-md-6">
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label class="lbl" [for]="jobNameLBL">Job Name<span class="requiredField">*</span> </label>
                    <input type="search" kendoTextBox id="jobNameId" [(ngModel)]="orderdetail.jobName" #jobNameLBL
                           (blur)="isOrderValid()"
                           [ngClass]="{warningErrorBorder : orderDetailsForm?.isInvalidJobName && orderDetailsForm?.isSubmitted }"
                           class="kendoInput" [maxlength]="30"
                           tabindex="1" />
                  </div>
                  <!--<div class="form-group">
                    <label class="lbl" [for]="jobCityLBL">City<span class="requiredField">*</span> </label>
                    <input kendoTextBox [(ngModel)]="orderdetail.jobCity"
                           #jobCityLBL
                           (blur)="isOrderValid()"
                           class="kendoInput"
                           [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobCity && orderDetailsForm.isSubmitted }"
                           [maxlength]="25"
                           tabindex="2"
                           [disabled]="jobCityDisabled" />
                  </div>-->
                  <!--<div class="form-group">
                    <label class="lbl" [for]="jobStateLBL">State<span class="requiredField">*</span> </label>
                    <kendo-dropdownlist class="kendoInput" #jobStateLBL
                                        [(ngModel)]="orderdetail.jobState"
                                        [data]="stateList"
                                        (valueChange)="isOrderValid()"
                                        [filterable]="true"
                                        textField="stateDescription"
                                        valueField="stateDescription"
                                        [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobState && orderDetailsForm.isSubmitted }"
                                        tabindex="3"
                                        (filterChange)="handleStatesFilterChange($event)">
                    </kendo-dropdownlist>
                  </div>-->
                  <div class="form-group">
                    <label class="lbl" [for]="poLBL">PO<span class="requiredField">*</span> </label>
                    <input kendoTextBox [(ngModel)]="orderdetail.po"
                           #poLBL (blur)="isOrderValid()"
                           class="kendoInput"
                           [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidPO && orderDetailsForm.isSubmitted }"
                           maxlength="30"
                           tabindex="4" />
                  </div>
                  <div class="form-group">
                    <label class="lbl" [for]="marketSegmentLBL">Market Segment<span class="requiredField">*</span> </label>
                    <kendo-dropdownlist class="kendoInput" #marketSegmentLBL
                                        [(ngModel)]="orderdetail.marketSegment"
                                        [data]="marketSegments"
                                        (valueChange)="isOrderValid()"
                                        textField="name"
                                        valueField="value"
                                        [filterable]='false'
                                        [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidMarketSegment && orderDetailsForm.isSubmitted }"
                                        tabindex="5">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group">
                    <label class="lbl" [for]="frieghtTermsLBL">Freight Terms<span class="requiredField">*</span> </label>
                    <kendo-dropdownlist class="kendoInput" #frieghtTermsLBL
                                        [(ngModel)]="orderdetail.freightTerms"
                                        [data]="getFreightTerms$ | async"
                                        (valueChange)="isOrderValid()"
                                        textField="name"
                                        valueField="value"
                                        [filterable]='false'
                                        [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightTerms && orderDetailsForm.isSubmitted }"
                                        tabindex="6">
                    </kendo-dropdownlist>

                  </div>
                  <div class="form-group">
                    <label class="lbl" [for]="requestDateLBL">
                      Request Date
                    </label>
                    <kendo-datepicker class="kendoInput" [(ngModel)]="orderdetail.requestDate"
                                      placeholder="MM/DD/YYYY"
                                      #requestDateLBL format="MM/dd/yyyy"
                                      [min]="minRequestDate"
                                      [max]="maxRequestDate"
                                      [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidRequestDate && orderDetailsForm.isSubmitted }"
                                      [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" tabindex="7">
                    </kendo-datepicker>
                  </div>

                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="form-group">
                    <label class="lbl" [for]="commentsLBL">Comments </label>
                    <textarea kendoTextArea #commentsLBL class="kendoInput textArea" [maxlength]="maxChars"
                              [(ngModel)]="orderdetail.comments"></textarea>



                    <!--(keyup)="commenttxtArea($event)"
                    [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidComments && orderDetailsForm.isSubmitted }"
                    tabindex="16"></textarea>-->
                    <!--placeholder="{{expressCheckoutControlTexts.commentsLbl2?expressCheckoutControlTexts.commentsLbl2:orderdetailsLbl.commentsLbl2}}" tabindex="16"></textarea>-->
                    <!--<div class="LeftCls"> {{expressCheckoutControlTexts.characterRemainingLbl?expressCheckoutControlTexts.characterRemainingLbl:orderdetailsLbl.characterRemainingLbl}}: {{commentslength}}/{{maxChars}}</div>-->

                  </div>
                  <div class="form-group">
                    <span>The displayed Subtotal/Total Price does not include freight charges. The customer is responsible for all freight charges, calculated according to the shipping location listed for each item.</span>
                    <br /><br />
                    <b>Total Price: {{calculateOrderTotal | currency}}</b>
                    <br />
                    <div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
                      <button kendoButton [icon]="'shopping-cart'" *ngIf="hasPlaceOrderAccess"
                              (click)="placeOrder()" [disabled]="orderInProcess" class="m-3" primary="true">
                        Confirm Order<kendo-loader *ngIf="orderInProcess" style="color:blue"></kendo-loader>
                      </button>
                    </div>
                    <br />
                    <span>After clicking 'Confirm Order' a warning message will pop up if any selected items are no longer available. Any unavailable items will be removed from your selections, and you will need to select 'Confirm Order' again to proceed with the updated order. Orders submitted through the Overstock page are subject to Kawneer Sales Terms and Conditions and will be processed by a dedicated Kawneer Team. Once the order is submitted, you will receive an email confirming its submission to our team for processing. </span><br />
                  </div>
                </div>
                &nbsp;


              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-12">

              <!--<div class="d-flex justify-content-center align-items-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
                <button kendoButton [icon]="'shopping-cart'" *ngIf="hasPlaceOrderAccess"
                        (click)="placeOrder()" [disabled]="orderInProcess" class="m-3" primary="true">
                  Confirm Order<kendo-loader *ngIf="orderInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>-->
            </div>
          </div>
        </div>
      </section>

    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>

<section>
  <kendo-dialog *ngIf="orderAcknowledgementDialog.opened">
    <div style="text-align: center; margin: 30px;" *ngIf="!orderAcknowledgementDialog.isError">
      <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
            style="font-size:50px;color:green"></span>
      <p>Thank you for your order!</p>
      <h4>You will receive an email shortly containing the order details.</h4>
      <p>
        Order # <strong>{{orderConfirmationNo}}</strong>
      </p>
      <p>
        <button kendoButton primary="true" style="width: 300px;"
                (click)="continueShopping()">
          <!--[routerLink]="['/home']">-->
          Continue Shopping
        </button>
      </p>
    </div>
    <div style="text-align: center; margin: 30px;" *ngIf="orderAcknowledgementDialog.isError">
      <span class="k-icon k-i-close-outline k-i-x-outline k-i-error"
            style="font-size:50px;color:red"></span>
      <h4>Error!</h4>
      <p>Sorry, an item you were attempting to order has been sold.  Please review your cart for updates.</p>
      <p>
        <button kendoButton primary="true" style="width: 300px;" (click)="closeOrderAckDialog()">Close</button>
      </p>
    </div>
  </kendo-dialog>
</section>

<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    Are you sure you want to remove this item?
    <b> : {{ gridItemToRemove.longItemNumber }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>


<section>
  <kendo-dialog *ngIf="showShippingAddressModal">
    <div class="row">
      <div class="col-sm-12">
        <kendo-grid #customarAddressGrid
                    [data]="customarAddressGridView"
                    class="advanceMainGridCls"
                    [sortable]="true"
                    [selectable]="false"
                    [navigable]="true"
                    [filterable]="true"
                    [groupable]="false"
                    [reorderable]="true"
                    [resizable]="false"
                    [sort]="addressGridstate.sort"
                    [pageable]="{ buttonCount: 5, info: true, responsive:true, pageSizes:[50,75,100] }"
                    [pageSize]="addressGridstate.take"
                    [skip]="addressGridstate.skip"
                    [columnMenu]="false"
                    (sort)="customerAddressGridSortChange($event)"
                    (pageChange)="customerAddressGridPageChange($event)"
                    (dataStateChange)="customerAddressDataStateChange($event)"
                    [filter]="addressGridstate.filter"
                    [loading]="shipToGridLoading">


          <kendo-grid-column field="selectonSwitch" title="{{customarAddressLabelText.selectAddressLbl}}" [width]="100" [filterable]="false">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <input type="radio" kendoRadioButton id="{{dataItem.id}}" [checked]="dataItem.isSelected===true? true: false"
                     (change)="selectShippingAddress(dataItem)" />
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="customerNumber" title="{{customarAddressLabelText.customerNumberLbl}}" [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="mailingName" title="{{customarAddressLabelText.nameLbl}}" [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="addressLine1" title="{{customarAddressLabelText.addressLine1Lbl}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="addressLine2" title="{{customarAddressLabelText.addressLine2Lbl}}" [columnMenu]="false"
                             [filterable]="true" [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="city" title="{{customarAddressLabelText.cityLbl}}" [columnMenu]="false" [filterable]="true"
                             [editable]="false">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="state" title="{{customarAddressLabelText.stateLbl}}" [columnMenu]="false" [width]="100"
                             [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="zipCode" title="{{customarAddressLabelText.zipcodeLbl}}" [filterable]="true">
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
              <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                <kendo-filter-contains-operator></kendo-filter-contains-operator>
              </kendo-grid-string-filter-cell>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>

      </div>
    </div>
    <div class="dialog-btn-section">
      <div class="row">
        <div class="col-sm-12 btn-align-center">
          <div class="btn-group" role="group">
            <button kendoButton (click)="closeAddressChangeModal()"
                    class=" m-3 btn k-button dialogBtnSize">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </kendo-dialog>
</section>

<div class="toast" *ngIf="toastMessage" [ngClass]="toastType">
  {{ toastMessage }}
</div>








